module.exports = __webpack_public_path__ + "img/fanzhuan03.8c397ea4.png";